import { intervalToDuration } from 'date-fns'

export const getYearsOldByBirthDate = (birth: string) => {
	const start = new Date(birth)

	if (!start) {
		throw new Error('Birth date is invalid')
	}

	const yearsOld = intervalToDuration({
		start: start,
		end: Date.now()
	})

	return yearsOld.years
}
